'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var numericString = {};

exports.__exports = numericString;
